import { Routes, Route, Navigate } from 'react-router-dom'

// Pages (to be built in subsequent phases)
import LandingPage       from './pages/LandingPage'
import UploadPage        from './pages/UploadPage'
import ValidationReport  from './pages/ValidationReport'
import PaymentPage       from './pages/PaymentPage'
import JoinMeetingPage   from './pages/JoinMeetingPage'
import AdminLogin        from './pages/AdminLogin'
import AdminDashboard    from './pages/AdminDashboard'
import NotFound          from './pages/NotFound'

// Route guard for admin-only pages
import AdminRoute from './components/AdminRoute'

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/"               element={<LandingPage />} />
      <Route path="/upload/:caseId" element={<UploadPage />} />
      <Route path="/report/:caseId" element={<ValidationReport />} />
      <Route path="/pay"             element={<PaymentPage />} />
      <Route path="/pay/:caseId"    element={<PaymentPage />} />
      <Route path="/join"            element={<JoinMeetingPage />} />

      {/* Admin routes */}
      <Route path="/admin"          element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/login"    element={<AdminLogin />} />
      <Route path="/admin/*"        element={
        <AdminRoute>
          <AdminDashboard />
        </AdminRoute>
      } />

      {/* Fallback */}
      <Route path="/404"            element={<NotFound />} />
      <Route path="*"               element={<Navigate to="/404" replace />} />
    </Routes>
  )
}
